import {
  DOWNLOADSETTLEMENTREPORTPARTNER_SUCCESS,
  DOWNLOADSETTLEMENTREPORTPARTNER_FAILED,
  RESET_DOWNLOADSETTLEMENTREPORTPARTNER,
  LOADING_DOWNLOADSETTLEMENTREPORTPARTNER,
  NETWORK_ERROR_DOWNLOADSETTLEMENTREPORTPARTNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DOWNLOADSETTLEMENTREPORTPARTNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case DOWNLOADSETTLEMENTREPORTPARTNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case DOWNLOADSETTLEMENTREPORTPARTNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_DOWNLOADSETTLEMENTREPORTPARTNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_DOWNLOADSETTLEMENTREPORTPARTNER:
      return (state = initialState);
    default:
      return state;
  }
};
